export default {
  post: {
    title: "Posting",
    listTitle: "Posting",
    addTitle: "Add New ",
    editTitle: "Edit",
    add: "Add",
    formTitle: "Title",
    formType: "Type",
    formContent: "Content",
    formTitlePlaceholder: " ",
    formContentPlaceholder: " ",
    formTypePlaceholder: "  ",
    formPhotos: "Add photos",
    formVideos: "Add video",
    formPDF: "Add PDF",
    formAgencies: "Agency",
    cancel: "Cancel",
    save: "Save",
    saveAndPost: "Save and Post",
    toast: {
      postSuccess: "Posted Success",
      saveSuccess: "Saved Success",
      deleteSuccess: "Deleted Success"
    },
    channelSelected: "Selected Agency",
    channelAll: "All Agency",
    activityLabel: "Notice",
    promotionLabel: "Promotion",
    exclusiveLabel: "Recommendation",
    posted: "Posted",
    foundedIn: "Founded in",
    notPost: "Not Post"
  }
};
